import { defineMessages } from 'react-intl';

export const i18n: {
	calendarTypeFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	calendarTypeFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	calendarTypeFilterLabel: {
		id: 'search-page.salesforce.filter.calendarType',
		defaultMessage: 'Calendar Type',
		description: 'Label for filtering Salesforce calendar events by their type',
	},
	calendarTypeFilterNoOptions: {
		id: 'search-page.salesforce.filter.calendarType.no-options',
		defaultMessage: 'No calendar types available',
		description:
			'Message shown in the Salesforce calendar type filter dropdown when no type options are available',
	},
});
